import { createSelector } from "@reduxjs/toolkit"
import { DateTime } from "luxon"

import { RootState } from "../reducers"

import {
  DepositWithWithdrawalStatus,
  selectSuperstackEligibleDeposits,
} from "./portal"

export const selectMintingFeeInfo = (state: RootState) =>
  state.receiptToken.feeInfo

export const selectAnnualMintingFee = createSelector(
  selectMintingFeeInfo,
  (feeInfo) =>
    Object.fromEntries(
      Object.entries(feeInfo).map(([key, info]) => [
        key,
        (info ? info.annualFee : 0n).toString(),
      ]),
    ),
)

export const selectDepositsWithReceiptTokenMinted = createSelector(
  selectSuperstackEligibleDeposits,
  (deposits) => deposits.filter((deposit) => BigInt(deposit.mintedAmount) > 0n),
)

export const selectMaximumLockOfEligibleDepositsFromCurrentDate =
  createSelector(selectSuperstackEligibleDeposits, (deposits) => {
    const maximumSuperstackLockPeriodInWeeks = deposits.reduce(
      (
        longestLockPeriodInWeeks: number,
        deposit: DepositWithWithdrawalStatus,
      ) => {
        const currentLock = deposit.locks[deposit.locks.length - 1]
        const lockEnd = DateTime.fromJSDate(new Date(currentLock.lockEnd))
        const differenceInWeeks = lockEnd.diff(DateTime.now(), "weeks").weeks

        return differenceInWeeks > longestLockPeriodInWeeks
          ? differenceInWeeks
          : longestLockPeriodInWeeks
      },
      0,
    )

    return maximumSuperstackLockPeriodInWeeks
  })

export const selectDepositFeeData = (state: RootState) =>
  state.receiptToken.depositFeeData

export const selectDepositMaxMintAmount = (state: RootState) =>
  state.receiptToken.depositFeeData.maxMintAmount

export const selectMaxPossibleTotalMintAmount = (state: RootState) =>
  state.receiptToken.maxPossibleTotalMintAmount
